import axios from "axios";
import {
  appendAuthInterceptor,
  requestWrapper,
} from "../../../Common/serviceFactory";
import { recommendedBy } from "../Constants";

const PROPOSAL_FILES_BASE_URL = "registration/Proposal docs";

const axiosProposalRefereeInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_REFEREE}`,
});

const axiosFilesInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_REFEREE_FILES}`,
});


const axiosCMSInstance = axios.create({
  baseURL: process.env.REACT_APP_CMS_REQUEST_BASE_URL,
});

appendAuthInterceptor(axiosProposalRefereeInstance);
appendAuthInterceptor(axiosFilesInstance);

const service = {
  async GetContats(filter) {
    return await requestWrapper(
      axiosProposalRefereeInstance.get(`/referee/find?sw=${filter}`)
    );
  },
   async getDaysLeft() {
    return await requestWrapper(
      axiosProposalRefereeInstance.get(`/referee/daysleft`)
    );
  },
  async registerReferee(request) {
    return await requestWrapper(
      axiosCMSInstance.post(`api/account/referee/register`, request)
    );
  },
  async getApplicant() {
    return await requestWrapper(
      axiosProposalRefereeInstance.get(`/applicant/get`)
    );
  },
  async GetProposalRefereesGroupedByStatus() {
    // const { userName } = props;
    return await requestWrapper(
      axiosProposalRefereeInstance.get(`/referee/status`)
    );
  },
  async GetProposalRefereeById(props) {
    const { proposalRefereeId } = props;
    return await requestWrapper(
      axiosProposalRefereeInstance.get(
        `/referee/${proposalRefereeId}/proposalreferee`
      )
    );
  },
  async CreateProposalReferee(props) {
    const { proposalId, contactId } = props;
    const recomendedBy = recommendedBy.Referee;
    return await requestWrapper(
      axiosProposalRefereeInstance.post(
        `/referee/create/${proposalId}/${contactId}/${recomendedBy}`
      )
    );
  },
  async UpdateProposalRefereeAnswer(props) {
    const { proposalRefereeId, status, details } = props;
    return await requestWrapper(
      axiosProposalRefereeInstance.post(
        `/referee/updateStatus/${proposalRefereeId}/${status}`,
        details
      )
    );
  },
  async createProposalPDF({ proposalId }) {
    return await requestWrapper(
      axiosProposalRefereeInstance.get(`/proposal/${proposalId}/GeneratePDF`, {
        params: {
          idType: "ProposalId",
          header: "",
        },
      })
    );
  },
  async downloadRawFile({ path }) {
    const response = await requestWrapper(
      axiosFilesInstance.get(`files/${path}`, {
        params: {
          cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
        },
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      })
    );

    if (!(response instanceof Blob)) {
      return;
    }

    const blob = new Blob([response], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  },
  async getProposalFiles(props) {
    const { proposalId } = props;
    return await requestWrapper(
      axiosFilesInstance.get(
        `files/?path=${PROPOSAL_FILES_BASE_URL}/${proposalId}`
      )
    );
  },
  async downloadProposalFiles(props) {
    const { id, fileName } = props;
    const filePath = `files/${PROPOSAL_FILES_BASE_URL}/${id}/${id}_${fileName}`;
    return await requestWrapper(
      axiosFilesInstance.get(filePath, {
        params: {
          cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
        },
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      })
    );
  },
  async UpdateRefereeRecommendation(props) {
    const { proposalReferee } = props;
    const proposalRefereeId = proposalReferee.itemID;
    return await requestWrapper(
      axiosProposalRefereeInstance.post(
        `/referee/${proposalRefereeId}/recommendation/update`,
        JSON.stringify(proposalReferee),
        { headers: { "Content-Type": "application/json" } }
      )
    );
  },
};

export default service;
